import { MagentoStockItem } from './magento-stock-item';

export interface MagentoProduct {
  id: number;
  sku: string;
  name: string;
  attribute_set_id: number;
  price: number;
  status: number;
  visibility: number;
  type_id: string;
  created_at: string;
  updated_at: string;
  weight: number;
  extension_attributes: {
    website_ids: number;
  };
  category_links: {
    position: number;
    category_id: string;
    extension_attributes: {};
  };
  bundle_product_options: {
    option_id: number;
    title: string;
    required: true;
    type: string;
    position: number;
    sku: string;
    product_links: {};
    extension_attributes: {};
  };
  stock_item: MagentoStockItem;
  total_count: number;
}
